import Vue from 'vue'
import VueRouter from 'vue-router'
import VueRouterMiddleware, { middleware } from 'vue-router-middleware'
import store from '../store'
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import { version } from '@/../package'

import Home from '../views/Home.vue'
import OpenFile from '../views/OpenFile.vue'

import Login from '../views/auth/Login.vue'
import ForgetPassword from '../views/auth/ForgetPassword.vue'
import ResetPassword from '../views/auth/ResetPassword.vue'

import AgentWhtc from '../views/agent/Whtc.vue'

// import AgentSearch from '../views/agent/Search.vue'
// import AgentWaitList from '../views/agent/WaitList.vue'
// import AgentList from '../views/agent/List.vue'
//import AgentEdit from '../views/agent/Edit.vue'
import UploadAmlDoc from '../views/agent/UploadAMLDoc.vue'
// import AgentExpired from '../views/agent/ExprList.vue'

// import JobList from '../views/job/List.vue'
 import JobInspect from '../views/job/Inspect.vue'
// import JobOldOrderList from '../views/job/OldOrderList.vue'
// import JobEdit from '../views/job/Edit.vue'
// import JobConvert from '../views/job/Convert.vue'
// import JobImpRenew from '../views/job/ImportRenew.vue'

import JobCheckRenew from '../views/job/CheckRenew.vue'

// import PaymentList from '../views/payment/List.vue'
// import PaymentEdit from '../views/payment/Edit.vue'

// import PackageList from '../views/package/List.vue'
// import PackageEdit from '../views/package/Edit.vue'
// import PackageExport from '../views/package/Export.vue'

// import AdminList from '../views/admin/List.vue'
// import AdminEdit from '../views/admin/Edit.vue'
import ChangePassword from '../views/admin/ChangePassword.vue'

// import RoleList from '../views/role/List.vue'
// import RoleEdit from '../views/role/Edit.vue'

// import ReportAgentLine from '../views/report/AgentLine.vue'
// import ReportAgentSearch from '../views/report/AgentSearch.vue'
// import ReportAgentReport from '../views/report/AgentReport.vue'
// import ReportPayment from '../views/report/Payment.vue'
// //import ReportShortPayment from '../views/report/ShortPayment.vue'
// import ReportNewJob from '../views/report/NewJob.vue'
// import ReportCommission from '../views/report/CommissionReport.vue'
// import ReportDailyNewJob from '../views/report/DailyNewJob.vue'
// import ReportDailyNewJobByComp from '../views/report/DailyNewJobByComp.vue'
import ReportAgentOrder from '../views/report/AgentOrder.vue'
import ReportAgentOrderAppUpLevel from '../views/report/AgentOrderAppUpLevel.vue'
import ReportAgentOrderPersonal from '../views/report/AgentOrderPersonal.vue'
// import ReportOrderBranch from '../views/report/OrderBranch.vue'

// import BankList from '../views/bank/List.vue'
// import BankEdit from '../views/bank/Edit.vue'

// import BranchList from '../views/branch/List.vue'
// import BranchEdit from '../views/branch/Edit.vue'

// import InsuranceList from '../views/insurance/List.vue'
// import InsuranceEdit from '../views/insurance/Edit.vue'

// import AgentOldList from '../views/agent/OldList.vue'
// import AgentOldListWait from '../views/agent/OldListWait.vue'

// import CommissionAgentList from '../views/commission/AgentList.vue'
// import CommissionConfirmAgentList from '../views/commission/ConfirmAgentList.vue'
// import CommissionAgentListPaid from '../views/commission/AgentListPaid.vue'

// import CommissionLineList from '../views/commission/LineList.vue'
// import CommissionConfirmLineList from '../views/commission/ConfirmLineList.vue'
// import CommissionLineListPaid from '../views/commission/LineListPaid.vue'
// import CommissionReport from '../views/commission/Report.vue'
// import RcvCommReport from '../views/commission/RcvCommReport.vue'
// import AgentCumuFee from '../views/commission/AgentCumuFee.vue'

// import insuranceIncomeList from '../views/commission/insuranceIncome/List.vue';
// import insuranceIncomeEdit from '../views/commission/insuranceIncome/Edit.vue';

// import ReportReward from '../views/report/Reward.vue'

import Page404 from '../views/Page404.vue'

const routes = [
  {
    path: '/404',
    name: 'page404',
    component: Page404
  },
  ...middleware(['auth-complete'], [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/openfile',
      name: 'openfile',
      component: OpenFile
    },
    {
      path: '/agent/Whtc',
      name: 'agent-whtc',
      component: AgentWhtc
    },
    // {
    //   path: '/agent/exprlist',
    //   name: 'agent-expired',
    //   component: AgentExpired
    // },
    // {
    //   path: '/agent/list',
    //   name: 'agent-list',
    //   component: AgentList
    // },
    // {
    //   path: '/agent/waitlist',
    //   name: 'agent-waitlist',
    //   component: AgentWaitList
    // },
    // {
    //   path: '/agent/search',
    //   name: 'agent-search',
    //   component: AgentSearch
    // },
    // {
    //   path: '/agent/edit/:slug?',
    //   name: 'agent-edit',
    //   component: AgentEdit
    // },
    {
      path: '/agent/uploadamldoc',
      name: 'upload-aml-doc',
      component: UploadAmlDoc
    },
    // {
    //   path: '/admin/list',
    //   name: 'admin-list',
    //   component: AdminList
    // },
    // {
    //   path: '/admin/edit/:slug?',
    //   name: 'admin-edit',
    //   component: AdminEdit
    // },
    {
      path: '/admin/changepassword',
      name: 'admin-change-password',
      component: ChangePassword
    },
    // {
    //   path: '/role/list',
    //   name: 'role-list',
    //   component: RoleList
    // },
    // {
    //   path: '/role/edit/:slug?',
    //   name: 'role-edit',
    //   component: RoleEdit
    // },
    // {
    //   path: '/job/list/:slug?',
    //   name: 'job-list',
    //   component: JobList
    // },
    {
      path: '/job/inspect',
      name: 'job-inspect',
      component: JobInspect
    },
    // {
    //   path: '/job/oldorderlist',
    //   name: 'job-oldorderlist',
    //   component: JobOldOrderList
    // },
    // {
    //   path: '/job/edit/:slug?',
    //   name: 'job-edit',
    //   component: JobEdit
    // },
    // {
    //   path: '/job/convert/:slug?',
    //   name: 'job-convert',
    //   component: JobConvert
    // },
    // {
    //   path: '/job/importrenew',
    //   name: 'job-imp-renew',
    //   component: JobImpRenew
    // },
    {
      path: '/job/checkrenew',
      name: 'job-check-renew',
      component: JobCheckRenew
    },
    // {
    //   path: '/payment/list',
    //   name: 'payment-list',
    //   component: PaymentList
    // },
    // {
    //   path: '/payment/edit/:slug?',
    //   name: 'payment-edit',
    //   component: PaymentEdit
    // },
    // {
    //   path: '/package/list',
    //   name: 'package-list',
    //   component: PackageList
    // },
    // {
    //   path: '/package/edit/:slug?',
    //   name: 'package-edit',
    //   component: PackageEdit
    // },
    // {
    //   path: '/package/export',
    //   name: 'package-export',
    //   component: PackageExport
    // },
    // {
    //   path: '/report/agent-line',
    //   name: 'report-agent-line',
    //   component: ReportAgentLine
    // },
    // {
    //   path: '/report/agent-search',
    //   name: 'report-agent-search',
    //   component: ReportAgentSearch
    // },
    // {
    //   path: '/report/agent-report',
    //   name: 'report-agent-report',
    //   component: ReportAgentReport
    // },
    // {
    //   path: '/report/payment',
    //   name: 'report-payment',
    //   component: ReportPayment
    // },
    // {
    //   path: '/report/shortpayment',
    //   name: 'report-shortpayment',
    //   component: ReportShortPayment
    // },
    // {
    //   path: '/report/newjob',
    //   name: 'report-newjob',
    //   component: ReportNewJob
    // },
    // {
    //   path: '/report/commission',
    //   name: 'report-commission',
    //   component: ReportCommission
    // },
    // {
    //   path: '/report/dailynewjob',
    //   name: 'report-dailynewjob',
    //   component: ReportDailyNewJob
    // },
    // {
    //   path: '/report/dailynewjobbycomp',
    //   name: 'report-dailynewjobbycomp',
    //   component: ReportDailyNewJobByComp
    // },
    {
      path: '/report/AgentOrder',
      name: 'report-agentorder',
      component: ReportAgentOrder
    },
    {
      path: '/report/AgentOrderAppUpLevel',
      name: 'report-agentorder-appuplevel',
      component: ReportAgentOrderAppUpLevel
    },
    {
      path: '/report/AgentOrderPersonal',
      name: 'report-agentorder-personal',
      component: ReportAgentOrderPersonal
    },
    // {
    //   path: '/report/OrderBranch',
    //   name: 'report-orderbranch',
    //   component: ReportOrderBranch
    // },
    // {
    //   path: '/bank/list',
    //   name: 'bank-list',
    //   component: BankList
    // },
    // {
    //   path: '/bank/edit/:slug?',
    //   name: 'bank-edit',
    //   component: BankEdit
    // },
    // {
    //   path: '/branch/list',
    //   name: 'branch-list',
    //   component: BranchList
    // },
    // {
    //   path: '/branch/edit/:slug?',
    //   name: 'branch-edit',
    //   component: BranchEdit
    // },
    // {
    //   path: '/insurance/list',
    //   name: 'insurance-list',
    //   component: InsuranceList
    // },
    // {
    //   path: '/insurance/edit/:slug?',
    //   name: 'insurance-edit',
    //   component: InsuranceEdit
    // },
    // {
    //   path: '/commission/agentlist',
    //   name: 'commission-agentlist',
    //   component: CommissionAgentList
    // },
    // {
    //   path: '/commission/confirmagentlist',
    //   name: 'commission-confirmagentlist',
    //   component: CommissionConfirmAgentList
    // },
    // {
    //   path: '/commission/agentlistpaid',
    //   name: 'commission-agentlistpaid',
    //   component: CommissionAgentListPaid
    // },
    // {
    //   path: '/commission/linelist',
    //   name: 'commission-linelist',
    //   component: CommissionLineList
    // },
    // {
    //   path: '/commission/confirmlinelist',
    //   name: 'commission-confirmlinelist',
    //   component: CommissionConfirmLineList
    // },
    // {
    //   path: '/commission/linelistpaid',
    //   name: 'commission-linelistpaid',
    //   component: CommissionLineListPaid
    // },
    // {
    //   path: '/commission/report',
    //   name: 'commission-report',
    //   component: CommissionReport
    // },
    // {
    //   path: '/commission/rcvcommreport',
    //   name: 'rcv-comm-report',
    //   component: RcvCommReport
    // },
    // {
    //   path: '/commission/insuranceIncome/list',
    //   name: 'commission-insuranceincome-list',
    //   component: insuranceIncomeList
    // },
    // {
    //   path: '/commission/insuranceIncome/edit/:slug?',
    //   name: 'commission-insuranceincome-edit',
    //   component: insuranceIncomeEdit
    // },
    // {
    //   path: '/commission/agentcumufee',
    //   name: 'agent-cumu-fee',
    //   component: AgentCumuFee
    // },
    // {
    //   path: '/report/reward',
    //   name: 'report-reward',
    //   component: ReportReward
    // },
  ]),
  ...middleware(['no-auth'], [
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    // {
    //   path: '/register',
    //   name: 'register',
    //   component: Register
    // },
    {
      path: '/forgetpassword',
      name: 'forgetpassword',
      component: ForgetPassword
    },
    {
      path: '/resetpassword',
      name: 'resetpassword',
      component: ResetPassword
    },
  ]),
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    //change route go to top
    return { x: 0, y: 0 };
  }
})

var DEFAULT_TITLE = 'SKLife-ศรีกรุงประกันชีวิต';
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
});

router.beforeEach((to, from, next) => {
  if (store.state.Admin.RefId != '' && Date.now() >= store.state.Admin.Expire * 1000) {
    store.commit('clearAuth', true);
    next({ name: 'login' });
  } else {
    //Check force change password
    // console.log('from', from, 'to', to, 'next')
    // console.log(store.state.Admin.IsForceChangePwd && !(to.name === 'admin-change-password' || to.name === 'resetpassword'))

    // if (to.name === 'login') {
    //   console.log('To Login')
    // }
    // else if (store.state.Admin.IsForceChangePwd && to.name !== 'admin-change-password' && to.name !== 'resetpassword') {
    //   next({ name: 'admin-change-password' });
    //   console.log('To Change Password')
    // } else
    //   console.log('No Change Password')


    //check app version
    const config = {
      headers: { Authorization: `Bearer ${store.state.Admin.Token}` }
    };
    const promise1 = axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/admin/getappversion', config)
      .then(function (res) {
        if (res.status == 200) {

          //console.log(res.data)

          if (res.data.Version != version) {
            window.alert('เวอร์ชั่นของระบบไม่ถูกต้อง (ล่าสุด ' + res.data.Value + ') กด ctrl+f5 เพื่อโหลดใหม่');
            window.location.href = '';
          }

          let menuWhtc50 = {
            IsShowMenu: res.data.MenuWhtc50 == "Y",
            FiscalYear: res.data.FiscalYear ? parseInt(res.data.FiscalYear) : 0,
          };

          store.commit('setMenuWhtc50', menuWhtc50);
        }
      })
      .catch(function (error) {
        console.log(error);
      });

    // //set insurance to store
    // const promise2 = new Promise((resolve, reject) => {
    //   if(store.state.Insurances.length == 0){
    //     axios.get(process.env.VUE_APP_API_URL+'/api/api/getinsurance',config)
    //     .then(function (res) {
    //         if(res.status == 200){
    //           store.commit('setInsurances',res.data);
    //           resolve();
    //         }else{
    //           window.alert('ไม่สามารถดึงข้อมูลบริษัทประกัน');
    //         }
    //     })
    //     .catch(function (error) {
    //       window.alert('ไม่สามารถดึงข้อมูลบริษัทประกัน');
    //     });
    //   }else{
    //     resolve();
    //   }
    // });

    // //set prefix to store
    // const promise3 = new Promise((resolve, reject) => {
    //   if(store.state.NamePrefix.length == 0){
    //     axios.get(process.env.VUE_APP_API_URL+'/api/api/getprefix',config)
    //     .then(function (res) {
    //         if(res.status == 200){
    //           store.commit('setNamePrefix',res.data);
    //           resolve();
    //         }else{
    //           window.alert('ไม่สามารถดึงข้อมูลคำนำหน้า');
    //         }
    //     })
    //     .catch(function (error) {
    //       window.alert('ไม่สามารถดึงข้อมูลคำนำหน้า');
    //     });
    //   }else{
    //     resolve();
    //   }
    // });

    // //set province to store
    // const promise4 = new Promise((resolve, reject) => {
    //   if(store.state.Provinces.length == 0){
    //     axios.get(process.env.VUE_APP_API_URL+'/api/api/getprovince',config)
    //     .then(function (res) {
    //         if(res.status == 200){
    //           store.commit('setProvinces',res.data);
    //           resolve();
    //         }else{
    //           window.alert('ไม่สามารถดึงข้อมูลคำนำหน้า');
    //         }
    //     })
    //     .catch(function (error) {
    //       window.alert('ไม่สามารถดึงข้อมูลคำนำหน้า');
    //     });
    //   }else{
    //     resolve();
    //   }
    // });


    //Promise.all([promise1,promise2,promise3,promise4]).then(function(values) {
    Promise.all([promise1]).then(function (values) {
      if (store.state.Admin.RefId != '' && store.state.RefreshToken == false && Date.now() >= ((store.state.Admin.Expire * 1000) - (120 * 60 * 1000))) {
        //not RefreshToken and less than 120 minute expire
        store.commit('setRefreshToken', true);
        axios.post(process.env.VUE_APP_OFFICEAPI_URL + '/api/authadmin/refreshtoken', {}, config)
          .then(function (res) {
            if (res.status == 200) {
              store.commit('setAuth', res.data.token);
              store.commit('setRefreshToken', false);
              next();
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        next();
      }
    });
  }



})

router.afterEach((to, from) => {
  axios.defaults.headers.fullreferer = window.location.href;
})

Vue.use(VueRouter)
Vue.use(VueRouterMiddleware, {
  router,
  middlewares: {
    // Convert to camelcase to dash string ex. requireAuth saves require-auth
    authComplete(params, to, from, next) {
      // Logic here
      if (store.state.Admin.RefId == '') {
        next({ name: 'login' });
      } else if (store.state.Admin.OTPConfirm == 0 && store.state.ServerType == 'member') {
        next({ name: 'verifyaccount', query: { refid: store.state.Admin.RefId } });
      } else {
        next();
      }
    },
    noVerify(params, to, from, next) {
      if (store.state.Admin.RefId != '' && store.state.Admin.OTPConfirm == 1) {
        next({ name: 'home' });
      } else {
        next();
      }
    },
    noAuth(params, to, from, next) {
      if (store.state.Admin.RefId != '') {
        next({ name: 'home' });
      }
      else {
        next();
      }
    },
    checkPermission(params, to, from, next) {
      // Get params
      next(params.includes('super-user'))
    }
  }
})

export default router
